import {
	AerCharacterCount,
	AerInput,
	AerInputErrorMessage,
	AerInputMessage,
	AerLabel,
	AerInputStructure as Root,
} from "./AerInputStructure";
export type { InputProps } from "./AerInputStructure";

export const AerInputStructure = {
	Root,
	Label: AerLabel,
	InputMessage: AerInputMessage,
	ErrorMessage: AerInputErrorMessage,
	CharacterCount: AerCharacterCount,
	Input: AerInput,
};
